/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdilocation.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edilocation";

export class AutogenModelEdilocation<RowType extends ModelRow> extends Endpoint<RowType, RowEdilocationFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdilocation extends ModelRow<RowEdilocationFields> {
	constructor(values?: Partial<RowEdilocationFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdilocationFields {
	company_id: string;
	"customer.activity_count": number;
	"customer.activity_start_date": Date;
	"customer.add_empty_distance_occ": string;
	"customer.add_finance_charge": string;
	"customer.address1": string;
	"customer.address2": string;
	"customer.allow_inc_in_frt": string;
	"customer.allow_web_tendering": string;
	"customer.auto_rate": string;
	"customer.auto_tax": string;
	"customer.available_template": number;
	"customer.average_bill": number;
	"customer.average_bill_c": string;
	"customer.average_bill_d": Date;
	"customer.average_bill_n": number;
	"customer.average_bill_r": number;
	"customer.average_pay_days": number;
	"customer.balance": number;
	"customer.balance_c": string;
	"customer.balance_d": Date;
	"customer.balance_n": number;
	"customer.balance_r": number;
	"customer.benchmark_ctg_uid": number;
	"customer.benchmark_tar_uid": number;
	"customer.bill_due_days": number;
	"customer.bill_format_flag": string;
	"customer.bill_template": number;
	"customer.bill_transfer_when": string;
	"customer.billed_loads": number;
	"customer.bl_logo": string;
	"customer.bl_logo_name": string;
	"customer.blanket_buy_tariff_id": string;
	"customer.blanket_sell_tariff_id": string;
	"customer.bridge_id": string;
	"customer.brokerage_filter": string;
	"customer.business_hours": string;
	"customer.business_number": string;
	"customer.buy_tariff_id": string;
	"customer.carrier_scorecard_exported": string;
	"customer.category": string;
	"customer.cert_of_ins_date": Date;
	"customer.charge_detention": string;
	"customer.chassis_chargeby": string;
	"customer.chassis_freedays": number;
	"customer.chassis_rate": number;
	"customer.chassis_rate_c": string;
	"customer.chassis_rate_d": Date;
	"customer.chassis_rate_n": number;
	"customer.chassis_rate_r": number;
	"customer.city": string;
	"customer.city_id": number;
	"customer.coll_thresh_pd1": number;
	"customer.coll_thresh_pd1_c": string;
	"customer.coll_thresh_pd1_d": Date;
	"customer.coll_thresh_pd1_n": number;
	"customer.coll_thresh_pd1_r": number;
	"customer.coll_thresh_pd2": number;
	"customer.coll_thresh_pd2_c": string;
	"customer.coll_thresh_pd2_d": Date;
	"customer.coll_thresh_pd2_n": number;
	"customer.coll_thresh_pd2_r": number;
	"customer.coll_thresh_pd3": number;
	"customer.coll_thresh_pd3_c": string;
	"customer.coll_thresh_pd3_d": Date;
	"customer.coll_thresh_pd3_n": number;
	"customer.coll_thresh_pd3_r": number;
	"customer.coll_thresh_pd4": number;
	"customer.coll_thresh_pd4_c": string;
	"customer.coll_thresh_pd4_d": Date;
	"customer.coll_thresh_pd4_n": number;
	"customer.coll_thresh_pd4_r": number;
	"customer.collections_id": string;
	"customer.collections_ok": string;
	"customer.company_id": string;
	"customer.confidence_level": number;
	"customer.container_chargeby": string;
	"customer.container_freedays": number;
	"customer.container_rate": number;
	"customer.container_rate_c": string;
	"customer.container_rate_d": Date;
	"customer.container_rate_n": number;
	"customer.container_rate_r": number;
	"customer.contract_cbc": string;
	"customer.contract_ccc": string;
	"customer.contract_gbc": string;
	"customer.contract_gcc": string;
	"customer.contract_sbc": string;
	"customer.contract_scc": string;
	"customer.controlling_carrier_code": string;
	"customer.conversion_date": Date;
	"customer.cost_ctg_uid": number;
	"customer.cost_tar_uid": number;
	"customer.covered_template": number;
	"customer.cp_logo": string;
	"customer.cp_logo_name": string;
	"customer.credit_application": string;
	"customer.credit_check_date": Date;
	"customer.credit_limit": number;
	"customer.credit_limit_c": string;
	"customer.credit_limit_d": Date;
	"customer.credit_limit_n": number;
	"customer.credit_limit_r": number;
	"customer.credit_status": string;
	"customer.credit_warning_pct": number;
	"customer.ctg_uid": number;
	"customer.currency_type": string;
	"customer.cust_requestor_load_id": string;
	"customer.cust_stmt_template": number;
	"customer.d_and_b_code": string;
	"customer.d_and_b_date": Date;
	"customer.d_and_b_number": string;
	"customer.days_between_calls": number;
	"customer.deadhead_target": number;
	"customer.ded_last_fixed_cost_billdt": Date;
	"customer.dedicated_cycle": string;
	"customer.dedicated_revenue_code_id": string;
	"customer.dedicated_seg_alloc_code": string;
	"customer.dedicated_start_day": string;
	"customer.dedicated_template": number;
	"customer.def_rate_confirm_temp": number;
	"customer.delivered_template": number;
	"customer.departure_date_at": string;
	"customer.disable_automatic_tracking": string;
	"customer.display_eta": string;
	"customer.display_ysplit_stops": string;
	"customer.distance_method": string;
	"customer.distance_profile": string;
	"customer.distance_source": string;
	"customer.distance_type": string;
	"customer.dot_number": string;
	"customer.driver_load": string;
	"customer.empty_distance_charge_id": string;
	"customer.empty_distance_rate": number;
	"customer.enable_notifications": string;
	"customer.enforce_dep_dates": string;
	"customer.entered_date": Date;
	"customer.excise_taxable": string;
	"customer.expected_close": Date;
	"customer.extend_rates": string;
	"customer.factor_percent": number;
	"customer.factor_receivables": string;
	"customer.factoring_id": string;
	"customer.fak_profile_id": string;
	"customer.fourkites_customer_id": string;
	"customer.fuel_amount": number;
	"customer.fuel_base_price": number;
	"customer.fuel_credit": string;
	"customer.fuel_method": string;
	"customer.fuel_percent": number;
	"customer.fuel_price_region": string;
	"customer.fuel_surcharge_id": string;
	"customer.fuel_surchg_enddt": Date;
	"customer.fuel_surchg_strtdt": Date;
	"customer.fuel_variance": number;
	"customer.global_detention": string;
	"customer.google_place_id": string;
	"customer.gp_exclude": string;
	"customer.gp_exported": Date;
	"customer.gp_imported": Date;
	"customer.grace_period": number;
	"customer.high_balance": number;
	"customer.high_balance_c": string;
	"customer.high_balance_d": Date;
	"customer.high_balance_n": number;
	"customer.high_balance_r": number;
	"customer.ic_company_id": string;
	"customer.id": string;
	"customer.include_by_date": string;
	"customer.include_empty_distance": string;
	"customer.include_fuel_surcharge": string;
	"customer.include_split_point": string;
	"customer.integration_type": string;
	"customer.invoice_processing_id": string;
	"customer.is_active": string;
	"customer.is_consignee": string;
	"customer.is_distribution_center": string;
	"customer.is_drop_yard": string;
	"customer.is_geocoded": string;
	"customer.is_intercompany": string;
	"customer.is_pallets_required": string;
	"customer.is_shipper": string;
	"customer.is_trailer_pool_required": string;
	"customer.jaguar_id": number;
	"customer.last_bill_date": Date;
	"customer.last_fin_charge_dt": Date;
	"customer.last_pay_date": Date;
	"customer.last_ship_date": Date;
	"customer.latitude": number;
	"customer.location_id": string;
	"customer.longitude": number;
	"customer.macropoint_requestor_id": string;
	"customer.main_phone": string;
	"customer.manual_exchange": string;
	"customer.mark_plan_id": string;
	"customer.max_pay_percent": number;
	"customer.misc_bill_template": number;
	"customer.monthly_order_goal": number;
	"customer.motor_carrier_id": string;
	"customer.name": string;
	"customer.next_call_date": Date;
	"customer.next_rec_call": Date;
	"customer.nxt_action_code_id": string;
	"customer.nxt_action_date": Date;
	"customer.operations_user": string;
	"customer.order_count": number;
	"customer.order_detail_at": string;
	"customer.order_start_date": Date;
	"customer.override_max_city_radius": number;
	"customer.p44_profile_id": string;
	"customer.paid_loads": number;
	"customer.pay_days_date": Date;
	"customer.pay_days_orders": number;
	"customer.payee_id": string;
	"customer.pd0_alert": number;
	"customer.pd1_np_auto": string;
	"customer.pd1_sp_auto": string;
	"customer.pd1_sp_thresh": number;
	"customer.pd1_sp_thresh_c": string;
	"customer.pd1_sp_thresh_d": Date;
	"customer.pd1_sp_thresh_n": number;
	"customer.pd1_sp_thresh_r": number;
	"customer.pd2_np_auto": string;
	"customer.pd2_sp_auto": string;
	"customer.pd2_sp_thresh": number;
	"customer.pd2_sp_thresh_c": string;
	"customer.pd2_sp_thresh_d": Date;
	"customer.pd2_sp_thresh_n": number;
	"customer.pd2_sp_thresh_r": number;
	"customer.pd3_np_auto": string;
	"customer.pd3_sp_auto": string;
	"customer.pd3_sp_thresh": number;
	"customer.pd3_sp_thresh_c": string;
	"customer.pd3_sp_thresh_d": Date;
	"customer.pd3_sp_thresh_n": number;
	"customer.pd3_sp_thresh_r": number;
	"customer.pd4_np_auto": string;
	"customer.pd4_sp_auto": string;
	"customer.pd4_sp_thresh": number;
	"customer.pd4_sp_thresh_c": string;
	"customer.pd4_sp_thresh_d": Date;
	"customer.pd4_sp_thresh_n": number;
	"customer.pd4_sp_thresh_r": number;
	"customer.plc_uid": number;
	"customer.post_summary_dtl": string;
	"customer.potential": number;
	"customer.potential_c": string;
	"customer.potential_d": Date;
	"customer.potential_n": number;
	"customer.potential_r": number;
	"customer.prev_code": string;
	"customer.primary_agency": string;
	"customer.primary_commodity_id": string;
	"customer.primary_contact": string;
	"customer.primary_sort": string;
	"customer.primary_trailer_type": string;
	"customer.print_containers": string;
	"customer.progress_template": number;
	"customer.prospect_type_id": string;
	"customer.quebec_number": string;
	"customer.quote_days_to_expire": number;
	"customer.rate_override_nmfc_code": string;
	"customer.reassign_profile_id": string;
	"customer.rec_call_days": number;
	"customer.remarks": string;
	"customer.require_tracking": string;
	"customer.required_vendor": string;
	"customer.revenue": number;
	"customer.revenue_c": string;
	"customer.revenue_d": Date;
	"customer.revenue_n": number;
	"customer.revenue_r": number;
	"customer.revenue_start_date": Date;
	"customer.routing_guide_profile_id": string;
	"customer.sales_manager_id": string;
	"customer.sales_status_id": string;
	"customer.salesperson_id": string;
	"customer.search_city": string;
	"customer.search_state_id": string;
	"customer.search_zip_code": string;
	"customer.secondary_sort": string;
	"customer.sell_tariff_id": string;
	"customer.service_fail_cons": string;
	"customer.service_fail_drop": string;
	"customer.service_fail_pick": string;
	"customer.service_fail_ship": string;
	"customer.service_failures": string;
	"customer.service_failures_review": string;
	"customer.shipment_ident_type": string;
	"customer.sic_code": string;
	"customer.smc3_profile_id": string;
	"customer.start_date": Date;
	"customer.state_id": string;
	"customer.summary_billing": string;
	"customer.summary_template": number;
	"customer.tar_uid": number;
	"customer.target_profit": number;
	"customer.tenfour_customer_id": string;
	"customer.toll_oc_exempt": string;
	"customer.tracking_hours_prior": number;
	"customer.trimble_place_id": string;
	"customer.type_of": string;
	"customer.use_local_mile": string;
	"customer.vm_part_update": string;
	"customer.waterfall_auto_route_guides": string;
	"customer.waterfall_lead_time": number;
	"customer.waterfall_notify_email": string;
	"customer.waterfall_process": string;
	"customer.website_url": string;
	"customer.wf_auto_renbill": string;
	"customer.wf_autobill": string;
	"customer.wf_bwop": string;
	"customer.wf_queue": number;
	"customer.zip_code": string;
	"customer.zone_id": string;
	customer_id: string;
	edi_location: string;
	edi_location_qual: string;
	id: string;
	"location.address1": string;
	"location.address2": string;
	"location.appt_required": string;
	"location.assigned_to": string;
	"location.bseg": string;
	"location.category": string;
	"location.cbsa_port_id": string;
	"location.chassis_owner": string;
	"location.chassis_pool": string;
	"location.city_id": number;
	"location.city_name": string;
	"location.class_rqmt": string;
	"location.comments": string;
	"location.company_id": string;
	"location.container_pool": string;
	"location.container_vendor": string;
	"location.cust_id": string;
	"location.customer_id": string;
	"location.days_between_calls": number;
	"location.ded_rqmt_type": string;
	"location.ded_type": string;
	"location.def_commodity_desc": string;
	"location.def_commodity_id": string;
	"location.delivery_date_option": string;
	"location.directions": string;
	"location.disable_loc_rating": string;
	"location.dl_gen_cost": number;
	"location.dl_gen_repower": number;
	"location.dl_haz_cost": number;
	"location.dl_haz_repower": number;
	"location.dl_hvl_cost": number;
	"location.dl_hvl_repower": number;
	"location.dl_load_time": number;
	"location.dl_svc_cost": number;
	"location.dl_svc_repower": number;
	"location.dl_unload_time": number;
	"location.driver_load_id": string;
	"location.driver_unload_id": string;
	"location.ds_capacity_cost": number;
	"location.ds_model_flag": string;
	"location.extra_handling_time": number;
	"location.filer_code": string;
	"location.foreign_port": string;
	"location.friday_close": Date;
	"location.friday_open": Date;
	"location.fuel_price_region": string;
	"location.google_place_fm_address": string;
	"location.google_place_id": string;
	"location.google_place_type": string;
	"location.id": string;
	"location.include_xref_trailers": string;
	"location.insur_amt_rqrd": number;
	"location.insur_amt_rqrd_c": string;
	"location.insur_amt_rqrd_d": Date;
	"location.insur_amt_rqrd_n": number;
	"location.insur_amt_rqrd_r": number;
	"location.is_active": string;
	"location.is_consignee": string;
	"location.is_customer": string;
	"location.is_customs_broker": string;
	"location.is_dist_center": string;
	"location.is_dl_gen": string;
	"location.is_dl_haz": string;
	"location.is_dl_hvl": string;
	"location.is_dl_svc": string;
	"location.is_drop_yard": string;
	"location.is_geocoded": string;
	"location.is_outside_terminal": string;
	"location.is_prospect": string;
	"location.is_remote_terminal": string;
	"location.is_shipper": string;
	"location.is_steamship": string;
	"location.is_terminal": string;
	"location.is_trailer_pool": string;
	"location.is_trailer_wash": string;
	"location.is_truckstop": string;
	"location.last_used_date": Date;
	"location.latitude": number;
	"location.layover": string;
	"location.load_unload_count": number;
	"location.load_unload_excl": string;
	"location.load_unload_param": string;
	"location.loading_instructs": string;
	"location.loading_time": number;
	"location.longitude": number;
	"location.ltl_optimize_time_per_spot": number;
	"location.ltl_seg_alloc_code": string;
	"location.manual_exchange": string;
	"location.max_drvr_complaint": number;
	"location.max_pallet_balance": number;
	"location.max_payment_code_amt": number;
	"location.max_payment_code_amt_c": string;
	"location.max_payment_code_amt_d": Date;
	"location.max_payment_code_amt_n": number;
	"location.max_payment_code_amt_r": number;
	"location.model_flag": string;
	"location.monday_close": Date;
	"location.monday_open": Date;
	"location.name": string;
	"location.need_clean_trailer": string;
	"location.next_call_date": Date;
	"location.no_fuel_radius_inbound": number;
	"location.no_fuel_radius_outbound": number;
	"location.no_stop_miles": number;
	"location.on_duty_not_driving_mins": number;
	"location.pallet_balance": number;
	"location.pallets_required": string;
	"location.payment_api_excluded": string;
	"location.pickup_date_option": string;
	"location.plc_uid": number;
	"location.pnn_city_id": number;
	"location.pnn_city_name": string;
	"location.pnn_state": string;
	"location.pnn_zip_code": string;
	"location.port_id": string;
	"location.prev_code": string;
	"location.primary_agency": string;
	"location.radius": number;
	"location.regulated": string;
	"location.reload_rqmt": string;
	"location.reserve_mins": number;
	"location.salesperson": string;
	"location.saturday_close": Date;
	"location.saturday_open": Date;
	"location.shuttle_capacity": string;
	"location.state": string;
	"location.sunday_close": Date;
	"location.sunday_open": Date;
	"location.swap_cost": number;
	"location.team_rqmt": string;
	"location.thursday_close": Date;
	"location.thursday_open": Date;
	"location.trailer_pool_min": number;
	"location.trailer_pool_radius": number;
	"location.trailer_pool_size": number;
	"location.trailer_wash_vend": string;
	"location.trimble_place_id": string;
	"location.trip_starter": string;
	"location.tuesday_close": Date;
	"location.tuesday_open": Date;
	"location.tw_seg_code": string;
	"location.unload_instructs": string;
	"location.unloading_time": number;
	"location.website_url": string;
	"location.wednesday_close": Date;
	"location.wednesday_open": Date;
	"location.zip_code": string;
	location_id: string;
	location_type: string;
	partner_id: string;
	version: string;
}

